import { render, staticRenderFns } from "./PaddleCoupons.vue?vue&type=template&id=22cb4c00&scoped=true&"
import script from "./PaddleCoupons.vue?vue&type=script&lang=js&"
export * from "./PaddleCoupons.vue?vue&type=script&lang=js&"
import style0 from "./PaddleCoupons.vue?vue&type=style&index=0&id=22cb4c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb4c00",
  null
  
)

export default component.exports